import React,{Component} from 'react';
import {Toast} from '@react/react-spectrum/Toast';
import i18n from "../../i18n";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next/src/index";
import {enableSuccessToastInfo,enableTokenizerErrorToastInfo,showApiErrorMessage,showScriptErrorMessage,showCyberSourceErrorMessage, showNoWalletEventErrorMessage, showGenericErrorToast, showMemoApiErrorMessage} from "../../actions/ToastActions";

class ToastInfo extends Component{

    constructor(props){
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
    }

    handleOnClose(){
        this.props.setSuccessToastFlag(false);
        this.props.setTokenizerErrorFlag(false);
        this.props.showApiErrorMessage(false);
        this.props.showScriptErrorMessage(false);
        this.props.showCyberSourceErrorMessage(false);
        this.props.showNoWalletEventErrorMessage(false);
        this.props.showMemoApiErrorMessage(false);
    }
    render(){
        let toast = '';
        if(this.props.showSuccessMsg){
            toast =  <Toast closable onClose={this.handleOnClose} variant="success">{i18n.t('successMessage')}</Toast>;
        }
        if(this.props.showTokenizerErrorToast){
            toast =  <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('tokenizerErrorMessage')}</Toast>;
        }
        if(this.props.showApiErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('serverErrorMessage')}</Toast>;
        }
        if(this.props.showMemoApiErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('memoErrorMessage')}</Toast>;
        }
        if(this.props.showScriptErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('scriptErrorMessage')}</Toast>;
        }        
        if(this.props.showCyberSourceErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('cyberSourceErrorMessage')}</Toast>;
        }
        if(this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_MISSING_DATA_INFO") > -1 && this.props.showNoWalletEventErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="info">{i18n.t('noWalletEventErrorMessage')}</Toast>;
        }
        if(this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_MISSING_COUNTRY_ERROR") > -1 && this.props.showGenericErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('missingCountryErrorMessage')}</Toast>;
        }
        if(this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_TNC_ERROR") > -1 && this.props.showTnCErrorToast){
            toast = <Toast closable onClose={this.handleOnClose} variant="error">{i18n.t('missingTnCErrorMessage')}</Toast>;
        }
        return(
            <div style={{margin:'10px 0 0 10px',textAlign:'center'}}>
                {toast}
            </div>
        )
    }
}


const mapStateToProps = (state)=>{
    return{
        showSuccessMsg:state.ToastReducer.showSuccessToast,
        showTokenizerErrorToast:state.ToastReducer.showTokenizerErrorToast,
        showApiErrorToast: state.ToastReducer.showApiErrorToast,
        showScriptErrorToast: state.ToastReducer.showScriptErrorToast,
        showCyberSourceErrorToast: state.ToastReducer.showCyberSourceErrorToast,
        showNoWalletEventErrorToast: state.ToastReducer.showNoWalletEventErrorToast,
        showGenericErrorToast: state.ToastReducer.showGenericErrorToast,
        showTnCErrorToast: state.ToastReducer.showTnCErrorToast,
        showMemoApiErrorToast: state.ToastReducer.showMemoApiErrorToast,
        featureFlags: state.AppReducer.featureFlags
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        setSuccessToastFlag:(flag)=>{dispatch(enableSuccessToastInfo(flag))},
        setTokenizerErrorFlag:(flag)=>{dispatch(enableTokenizerErrorToastInfo(flag))},
        showApiErrorMessage:(flag)=>{dispatch(showApiErrorMessage(flag))},
        showMemoApiErrorMessage:(flag)=>{dispatch(showMemoApiErrorMessage(flag))},
        showScriptErrorMessage:(flag)=>{dispatch(showScriptErrorMessage(flag))},
        showCyberSourceErrorMessage:(flag)=>{dispatch(showCyberSourceErrorMessage(flag))},
        showNoWalletEventErrorMessage:(flag)=>{dispatch(showNoWalletEventErrorMessage(flag))},
        showGenericErrorMessage:(flag)=>{dispatch(showGenericErrorToast(flag))},
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ToastInfo));

